/**
 * Currency helpers
 *
 * The API returns currency as an object: { code, symbol, name }
 * (from Organization::getCurrency()). These helpers handle both
 * a plain string code and the object shape.
 */

export const getCurrencyCode = (currency) => {
  if (!currency) return 'USD';
  if (typeof currency === 'string') return currency;
  return currency.code ?? 'USD';
};

export const getCurrencySymbol = (currency) => {
  if (!currency) return '$';
  if (typeof currency === 'object') return currency.symbol ?? '$';
  return '$';
};

export const formatCurrency = (amount, currency = 'USD') => {
  if (amount == null || amount === '') return '—';
  const code = getCurrencyCode(currency);
  try {
    return new Intl.NumberFormat('en-US', {
      style:    'currency',
      currency: code,
    }).format(Number(amount));
  } catch {
    // Fallback if code is invalid
    const symbol = getCurrencySymbol(currency);
    return `${symbol}${Number(amount).toFixed(2)}`;
  }
};
